module.exports = __webpack_public_path__ + "static/media/magic.ea8e8381.svg";